// @ts-nocheck
import React, { useState } from "react";
import { Dropdown, IDropdownOption } from "@trussle/external-components";
import { useIsMobile } from "../../../../hooks/useIsMobile";
import { CalculatorTabNames, CalculatorTypes } from "../../CalculatorPanels/calculatorTypes";

import "./styles.scss";

interface IControlPanelProps {
  defaultTab: number;
  multipleTabs: { id: number, name: CalculatorTypes }[];
  onChangeActiveTab: (tab: CalculatorTypes) => void;
}
export const CalculatorControlPanel: React.FunctionComponent<IControlPanelProps> = ({
  defaultTab,
  multipleTabs,
  onChangeActiveTab,
}) => {
  const isMobile = useIsMobile(960);
  const [activeTab, setActiveTab] = useState<number>(defaultTab);

  const options: IDropdownOption[] = multipleTabs.map(
    (item) => (
      { code: String(item.id), description: CalculatorTabNames[item.name] }
    ),
  );

  const onChangeTab = (tab) => {
    setActiveTab(tab.id);
    onChangeActiveTab(tab.name);
  };

  const onChangeMobileTab = (tab: number) => {
    const activeTabName = multipleTabs.find(
      (item) => item.id === tab,
    )?.name;
    setActiveTab(tab);
    onChangeActiveTab(activeTabName!);
  };

  return (
    <div className="control-tabs-wrapper">
      { isMobile
        ? (
          <Dropdown
            options={options}
            variant="secondary"
            value={activeTab}
            classOverrides={{
              select: "control-tabs-dropdown",
            }}
            onChange={(e: { target: { value: React.SetStateAction<string> } }) => onChangeMobileTab(Number(e.target.value))}
          />
        )
        : multipleTabs.map((tab, idx) => (
          <button
            key={tab.name}
            type="button"
            className={`control-tabs-item ${idx + 1 === activeTab && "active-tab"}`}
            onClick={() => onChangeTab(tab)}
          >
            {
               CalculatorTabNames[tab.name]
            }
          </button>
        ))}
    </div>
  );
};
